import React, { useState, useEffect } from "react";
import _ from "lodash";
import api from "../../utils/api";
import {
  _getSkipByPage,
  _getCSRFTokenValue,
  _getTranslation,
} from "../../utils/helper";

import { Loader, Pagination } from "../../atoms";
import { CardTender } from "../../cards";

const ClosedTenders = (props) => {
  const [posts, setPosts] = useState([]);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchPosts();
  }, [page]);

  const fetchPosts = async () => {
    setIsLoadingPosts(true);

    const POSTS_PER_PAGE = 6;
    const POSTS_SKIP = _getSkipByPage(page, POSTS_PER_PAGE);

    const fields = {
      skip: POSTS_SKIP,
      take: POSTS_PER_PAGE,
      page,
    };

    const csrfToken = await _getCSRFTokenValue();
    api
      .post("/tenders", fields, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        const TOTAL_POSTS = res.data.totalNodes;
        const TOTAL_PAGES = Math.ceil(TOTAL_POSTS / POSTS_PER_PAGE);

        setIsLoadingPosts(false);
        setPosts(res?.data?.contentData);
        setTotalPages(TOTAL_PAGES);
      })
      .catch((err) => {
        setIsLoadingPosts(false);
      });
  };

  return (
    <React.Fragment>
      {_.isArray(posts) && posts.length > 0 ? (
        <React.Fragment>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-8 sm:gap-y-12 lg:gap-y-16 mb-8">
            {posts.map((post, idx) => (
              <CardTender data={post} />
            ))}
          </div>
          <div className="flex items-center justify-center gap-x-6 mt-8">
            <Pagination
              page={page}
              totalPages={totalPages}
              setPage={(newPage) => {
                setPage(newPage);
              }}
            />
            {isLoadingPosts && <Loader />}
          </div>
        </React.Fragment>
      ) : isLoadingPosts ? (
        <Loader />
      ) : (
        <p>{_getTranslation("there_are_no_posts_available")}.</p>
      )}
    </React.Fragment>
  );
};

export default ClosedTenders;
